class FormattedFinalAmount {
  /**
   * @param {object} properties - properties of this object
   * @param {number} properties.amount
   * @param {string} properties.currencyCode
   * @param {string} properties.currencySymbol
   * @param {string} properties.formattedString
   */
  constructor(properties: $TSFixMe) {
    Object.assign(this, properties);
  }
}

class PromotionInfo {
  constructor(options = {}) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'discountAmount' does not exist on type '... Remove this comment to see the full error message
    this.discountAmount = options.discountAmount;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'discountPercent' does not exist on type ... Remove this comment to see the full error message
    this.discountPercent = options.discountPercent;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'promotionName' does not exist on type 'P... Remove this comment to see the full error message
    this.promotionName = options.promotionName;
  }

  getDiscountString() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'discountAmount' does not exist on type '... Remove this comment to see the full error message
    return this.discountAmount;
  }

  getDiscountPercent() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'discountPercent' does not exist on type ... Remove this comment to see the full error message
    return this.discountPercent;
  }

  getPromotionName() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'promotionName' does not exist on type 'P... Remove this comment to see the full error message
    return this.promotionName;
  }
}

class ProductPrice {
  /**
   * @param {string} productType - 'VerifiedCertificate' | 'SparkVerifiedCertificate' |
   *                             'Specialization' | SparkSpecialization
   * @param {string} productItemId - 'SOMEID'
   * @param {string} [currencyCode] - currency this product should be presented in. eg. 'USD'
   * @param {string} [countryIsoCode] - determines the country this product should be presented for. (DEPRECATED)
   * @param {string} [id] - Backend ProductPriceId eg. 'VerifiedCertificate~SOMEID~USD~US'
   * @param {number} [amount] - original price of product
   * @param {number} finalAmount - price this user has to pay, considering payment history and promotion
   * @param {string} priceCountryIsoCode - countryCode associated with price. Note: for display purposes, use
   *                                     formattedFinalAmount.currencyCode instead.
   * @param {Object} Converted into a FormattedFinalAmount instance
   */
  constructor(options = {}) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'productType' does not exist on type 'Pro... Remove this comment to see the full error message
    this.productType = options.productType;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'productItemId' does not exist on type 'P... Remove this comment to see the full error message
    this.productItemId = options.productItemId;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currencyCode' does not exist on type 'Pr... Remove this comment to see the full error message
    this.currencyCode = options.currencyCode;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'countryIsoCode' does not exist on type '... Remove this comment to see the full error message
    this.countryIsoCode = options.countryIsoCode;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'ProductPrice... Remove this comment to see the full error message
    this.id = options.id;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'amount' does not exist on type 'ProductP... Remove this comment to see the full error message
    this.amount = options.amount;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'finalAmount' does not exist on type 'Pro... Remove this comment to see the full error message
    this.finalAmount = options.finalAmount;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'priceCountryIsoCode' does not exist on t... Remove this comment to see the full error message
    this.priceCountryIsoCode = options.priceCountryIsoCode;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'formattedFinalAmount' does not exist on ... Remove this comment to see the full error message
    this.formattedFinalAmount = options.formattedFinalAmount
      ? // @ts-expect-error ts-migrate(2339) FIXME: Property 'formattedFinalAmount' does not exist on ... Remove this comment to see the full error message
        new FormattedFinalAmount(options.formattedFinalAmount)
      : null;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'promotionInfo' does not exist on type 'P... Remove this comment to see the full error message
    this.promotionInfo = options.promotionInfo ? new PromotionInfo(options.promotionInfo) : null;
  }

  /**
   * Throws an error if the price of this module is not displayable
   * due to a missing formattedFinalAmount object.
   */
  _displayCheck() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'formattedFinalAmount' does not exist on ... Remove this comment to see the full error message
    if (!this.formattedFinalAmount) {
      throw new Error('Cannot display price due to missing display format.');
    }
  }

  getOriginalAmount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'amount' does not exist on type 'ProductP... Remove this comment to see the full error message
    return this.amount;
  }

  getDisplayAmount() {
    this._displayCheck();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'formattedFinalAmount' does not exist on ... Remove this comment to see the full error message
    return this.formattedFinalAmount.amount;
  }

  getDisplayCurrencyCode() {
    this._displayCheck();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'formattedFinalAmount' does not exist on ... Remove this comment to see the full error message
    return this.formattedFinalAmount.currencyCode;
  }

  getDisplayCurrencySymbol() {
    this._displayCheck();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'formattedFinalAmount' does not exist on ... Remove this comment to see the full error message
    return this.formattedFinalAmount.currencySymbol;
  }

  getServerFormattedString() {
    this._displayCheck();

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'formattedFinalAmount' does not exist on ... Remove this comment to see the full error message
    return this.formattedFinalAmount.formattedString;
  }

  /**
   * The existence of promotionInfo means that there is a promotion.
   * It should always come with discountAmount and discountPercent.
   */
  hasPromotion() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'promotionInfo' does not exist on type 'P... Remove this comment to see the full error message
    return this.promotionInfo;
  }

  getDiscountPercent() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'promotionInfo' does not exist on type 'P... Remove this comment to see the full error message
    return (this.hasPromotion() && this.promotionInfo.getDiscountPercent()) || 0;
  }

  getDiscountAmount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'promotionInfo' does not exist on type 'P... Remove this comment to see the full error message
    return (this.hasPromotion() && this.promotionInfo.getDiscountAmount()) || 0;
  }

  getPromotionName() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'promotionInfo' does not exist on type 'P... Remove this comment to see the full error message
    return this.hasPromotion() ? this.promotionInfo.getPromotionName() : null;
  }
}

export default ProductPrice;
